<div class="action-node flow-node">
  @if (showIds()) {
    <span class="debug-id">{{ data.id }}</span>
  }

  <div class="node-actions">
    <span class="action">
      <i class="mynaui-pencil clickable" (pointerdown)="$event.stopPropagation()" (click)="editNode($event, data)"></i>
    </span>

    <span class="action">
      <i class="mynaui-trash clickable" (pointerdown)="$event.stopPropagation()" (click)="removeNode($event, data)"></i>
    </span>
  </div>
  <div class="node-wrap" [style]="{ borderColor: data?.nodeData?.styles?.borderColor || '' }">
    <div
      class="title"
      [style]="{
        backgroundColor: backgroundColor() || 'red',
        borderColor: data?.nodeData?.styles?.borderColor || '',
      }"
      data-testid="title">
      <div class="title-content" #marquee [class.marquee]="marquee.clientWidth < marquee.scrollWidth">
        <span class="title-type">{{ data.nodeData?.data?.application?.name }}</span>
      </div>
    </div>

    <div class="node-content" (pointerdown)="$event.stopPropagation()" (dblclick)="handleDoubleClick($event)">
      <div class="icon icon-background" data-testid="icon" [attr.aria-label]="data.label">
        <i [class]="data.nodeData.icon | nodeIcon"></i>
      </div>

      <div class="node-content-inputs-container">
        @for (input of data.inputs | keyvalue: sortByIndex; track input) {
          <app-node-socket
            [data]="data"
            [input]="input"
            [emit]="emit"
            [seed]="seed"
            [showLabel]="false"
            [nodeSocketType]="socketType.INPUT"
            nodeType="condition" />
        }
      </div>

      <div class="node-content-label-container">
        <span class="title-label" [title]="nodeLabel()">{{ nodeLabel() }}</span>
      </div>

      <div class="node-content-outputs-container">
        @for (output of data.outputs | keyvalue: sortByIndex; track output; let index = $index) {
          <app-node-socket
            [data]="data"
            [input]="output"
            [emit]="emit"
            [seed]="seed"
            [index]="index"
            [showLabel]="true"
            [nodeSocketType]="socketType.OUTPUT"
            nodeType="condition" />
        }
      </div>
    </div>
  </div>
</div>
